import uuid from 'uuid/v4';
import _, { cloneDeep, upperCase } from 'lodash';
import {
  TEMPLATE_TYPE_1,
  TEMPLATE_TYPE_2,
  TEMPLATE_TYPE_3,
  TEMPLATE_TYPE_4,
  TEMPLATE_TYPE_5,
  TEMPLATE_TYPE_7,
  TEMPLATE_TYPE_8,
  TEMPLATE_TYPE_9,
  AC_FUNTIONS_BASED_ON_TEMPLATE,
  TEMPLATE_1_NODE_CATEGORY,
  MRI_SAC_SPRING_FALL_STUDY_STI,
  AC_NODETYPE_DATAPOINT,
  AC_NODETYPE_OPERATOR,
  AC_NODETYPE_DEFINITION,
  AC_NODETYPE_FUNC,
  AC_DEFINITION_LABEL,
  AC_OPERATORS,
  TEMPLATE_1_TIME_PERIOD_LABEL_PREFIX,
} from './AutocodeConstants';
import {
  buildAutoCodeObject,
  extractGeoExpression,
  buildAutocodenodeWithNot,
} from '../../util/autocodeUtils';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from './AutocodeLabelsGenerator';
import AutocodeExpressionListGenerator from './AutocodeExpressionListGenerator';

import { GEOGRAPHY_BASES } from '../../actions/actionTypes';

export const functionsInComposer = [
  'COUNTRANGE',
  'MEAN',
  'MEANSCORE',
  'MEANNOZERO',
  'MEANSCORENOZERO',
  'MEANNONULL',
  'MEANSCORENONULL',
  'MEDIAN',
  'MEDIANDISCRETE',
  'MEDIANDISCRETENOZERO',
  'MEDIANNOZERO',
  'NETANY',
  'SUM',
  'NTILE',
  'NTILEWT',
  'VOLUME',
];

export const specialCharList = [
  ',',
  '+',
  '-',
  '*',
  '/',
  '<',
  '>',
  '=',
  '==',
  '<=',
  '>=',
];

const createDatapointForSelectionBox = (selectedNodeAnswers, answer) => {
  const getLabels = (labels, nodes, path) => {
    const ancestor = nodes.find(n => path.indexOf(n.pathId) === 0);
    if (ancestor && ancestor.children && ancestor.children.length > 0) {
      return getLabels(
        [...labels, ancestor.shortText],
        ancestor.children,
        path
      );
    }
    return labels;
  };

  const tempLabelsList = getLabels(
    [],
    [selectedNodeAnswers.root],
    answer.pathId
  );
  const question = tempLabelsList[tempLabelsList.length - 1];
  const labels = [
    ...selectedNodeAnswers.fixedLabels,
    ...tempLabelsList,
    answer.shortText,
  ];
  return {
    labels,
    template: selectedNodeAnswers.root.templateType,
    nodeLabel: selectedNodeAnswers.root.shortText,
    datatype: answer.datatype,
    keyword: answer.keyword,
    volKeyword: answer.volKeyword,
    path: answer.pathId,
    node: answer.node,
    midpoint: answer.midpoint,
    uniqueId: answer.uniqueId,
    modeled: answer.modeled,
    textPath: answer.textPath,
    shortText: `${question}: ${answer.shortText}`,
    rectype: answer.rectype,
    shortTextCatgView: answer.shortText,
    breadcrumbs: labels.join(' > '),
  };
};

export { createDatapointForSelectionBox };

const findAllTemplates = (node, obj) => {
  if (node) {
    if (node.children.length > 0) {
      node.children.forEach(n => findAllTemplates(n, obj));
    } else if (node.type === AC_NODETYPE_DATAPOINT) {
      obj.templateTypeArr.push(node.data.template);
      obj.nodeLabelArr.push(node.data.nodeLabel);
      obj.timePeriodArr.push(node.data.timePeriod);
    } else if (node.type === AC_NODETYPE_DEFINITION) {
      obj.templateTypeArr.push(AC_NODETYPE_DEFINITION);
      obj.nodeLabelArr.push(AC_DEFINITION_LABEL);
    }
  }
  return obj;
};

export const eachNodeTemplate = (selectedNodes, obj) => {
  obj =
    selectedNodes &&
    selectedNodes.reduce(
      (acc, elem) => {
        const tempObj = _.cloneDeep(findAllTemplates(elem, _.cloneDeep(obj)));
        acc.templateTypeArr = [
          ...acc.templateTypeArr,
          ...tempObj.templateTypeArr,
        ];
        acc.nodeLabelArr = [...acc.nodeLabelArr, ...tempObj.nodeLabelArr];
        acc.timePeriodArr = [...acc.timePeriodArr, ...tempObj.timePeriodArr];
        return acc;
      },
      {
        templateTypeArr: [],
        nodeLabelArr: [],
        timePeriodArr: [],
      }
    );
  return obj;
};

export const funcsEnable = selectedNodes => {
  const obj = {
    templateTypeArr: [],
    nodeLabelArr: [],
    timePeriodArr: [],
  };
  const objOfTemplateType = eachNodeTemplate(selectedNodes, obj);
  let sameTemplateType;
  let categoryCheckTemplate1 = true;
  if (objOfTemplateType !== undefined) {
    const temp = objOfTemplateType.templateTypeArr;
    sameTemplateType = temp.every((item, index, arr) => item === arr[0]);
    if (
      sameTemplateType &&
      objOfTemplateType.templateTypeArr[0] === TEMPLATE_TYPE_1
    ) {
      const count = objOfTemplateType.nodeLabelArr.filter(
        item => item === TEMPLATE_1_NODE_CATEGORY
      ).length;
      if (count === 0 || count === objOfTemplateType.nodeLabelArr.length)
        categoryCheckTemplate1 = true;
      else categoryCheckTemplate1 = false;
    }
  }
  return sameTemplateType && categoryCheckTemplate1;
};

/* Function list is based on templates, but as per PLAT-10453 we need to filter some
  functions based on study type. so all similar kind of logics should be handled here

  Applying filterFunctionListOnStudyType for only Template 1 list as of now.
  As per requierment of PLAT-10453, we need to filter volume function for Spring/Fall MRi studies.
  in future if similar custom requirement comes, we should write logic in one place which is
  filterFunctionListOnStudyType
 */
const filterFunctionListOnStudyType = (study, funcArr) => {
  if (study && study.sti === MRI_SAC_SPRING_FALL_STUDY_STI) {
    // removes volume function and returns others
    return funcArr.filter(item => item.label !== 'Volume');
  }
  return funcArr;
};

export const funcsInsideFX = (study, selectedNodes) => {
  let funcArr = [];
  const obj = {
    templateTypeArr: [],
    nodeLabelArr: [],
    timePeriodArr: [],
  };
  const objOfTemplateType = _.cloneDeep(eachNodeTemplate(selectedNodes, obj));
  let sameTemplateType;
  let sameTimePeriod;
  let nodeLabel;
  let timePeriod;
  let categoryCheckTemplate1 = true;
  let template;
  if (objOfTemplateType !== undefined) {
    sameTemplateType = objOfTemplateType.templateTypeArr.every(
      (item, index, arr) => item === arr[0]
    );
    sameTimePeriod = objOfTemplateType.timePeriodArr.every(
      (item, index, arr) => item === arr[0]
    );
    if (
      sameTemplateType &&
      objOfTemplateType.templateTypeArr[0] === TEMPLATE_TYPE_1
    ) {
      const count = objOfTemplateType.nodeLabelArr.filter(
        item => item === TEMPLATE_1_NODE_CATEGORY
      ).length;
      if (count === 0 || count === objOfTemplateType.nodeLabelArr.length)
        categoryCheckTemplate1 = true;
      else categoryCheckTemplate1 = false;
    }
    template = sameTemplateType ? objOfTemplateType.templateTypeArr[0] : '';
    nodeLabel = categoryCheckTemplate1 ? objOfTemplateType.nodeLabelArr[0] : '';
    timePeriod = sameTimePeriod ? objOfTemplateType.timePeriodArr[0] : '';
  }
  if (sameTemplateType) {
    switch (template) {
      case TEMPLATE_TYPE_1:
        switch (nodeLabel) {
          case TEMPLATE_1_NODE_CATEGORY:
            // append time period label to function labels
            funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_1_CATEGORY.map(
              f => ({
                ...f,
                label: `${f.label} ${timePeriod}`,
              })
            );
            break;
          case '':
            funcArr = [];
            break;
          default:
            /* Applying filterFunctionListOnStudyType for only Template 1 list as of now.
            As per requierment of PLAT-10453, we need to filter volume function for Spring/Fall MRi studies.
            in future if similar custom requirement comes, we should write logic in one place which is
            filterFunctionListOnStudyType
            */
            funcArr = filterFunctionListOnStudyType(
              study,
              AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_1_All
            ).map(f => ({
              ...f,
              // append time period label to function labels
              label: `${f.label} ${timePeriod}`,
            }));
            break;
        }
        break;
      case TEMPLATE_TYPE_2:
      case TEMPLATE_TYPE_8:
        funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_2_8;
        break;
      case TEMPLATE_TYPE_7:
        funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_7;
        break;
      case TEMPLATE_TYPE_4:
        funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_4;
        break;
      case TEMPLATE_TYPE_3:
      case TEMPLATE_TYPE_5:
      case TEMPLATE_TYPE_9:
        funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.TEMPLATE_3_5_9;
        break;
      case AC_NODETYPE_DEFINITION:
        funcArr = AC_FUNTIONS_BASED_ON_TEMPLATE.DEFINITION_FUNCTIONS;
        break;
      default:
        break;
    }
  }
  return funcArr;
};

const getKeywords = node => {
  const netArrayList = [];
  const genKeys = node => {
    if (node.type === AC_NODETYPE_OPERATOR) {
      genKeys(node.children[0]);
      genKeys(node.children[1]);
    } else if (node.type === AC_NODETYPE_DATAPOINT) {
      netArrayList.push(node.data.keyword);
    } else if (node.type === AC_NODETYPE_DEFINITION) {
      netArrayList.push(node.data.expression.slice(1));
    } else if (node.type === AC_NODETYPE_FUNC) {
      node.children.forEach(res =>
        res.type === (AC_NODETYPE_OPERATOR || AC_NODETYPE_DEFINITION)
          ? genKeys(res)
          : netArrayList.push(res.data.keyword)
      );
    }
  };
  genKeys(node);
  return netArrayList;
};

/// loop through all the nodes and see if can be combined as netAny
/// return true or false;(for all level)
export const CanCombineSelectedAsNetAny = topNode => {
  const selArray = [];
  if (!topNode) return false;
  topNode.children.forEach(n => n.selected && selArray.push(getKeywords(n)));
  const selArr = selArray.filter(n => n.length > 0);
  return _.every(selArr, n =>
    n.every(item => _.startsWith(_.upperCase(item), 'XNA'))
  );
};

// ****************************************************************************
/// show children as Question (Answer or Answer or Answer)
export const combineAllChildren = node => {
  if (node.type !== AC_NODETYPE_OPERATOR) return false;

  let nodePath = '0';
  let match = true;

  const checkIfPathsMatch = node => {
    const pathPrefix = node => {
      return _.join(_.dropRight(_.split(node.data.textPath, '.'), 1), '.');
    };

    node.children.forEach(n => {
      if (n.type === AC_NODETYPE_OPERATOR) {
        match =
          match &&
          node.data.type.symbol === n.data.type.symbol && // symbols below much match the parent symbol (AND, OR, etc)
          checkIfPathsMatch(n); // category/subcat/question must match
      } else if (n.type !== AC_NODETYPE_DATAPOINT) {
        // definition?
        match = false;
      } else if (match === true) {
        // is AC_NODETYPE_DATAPOINT
        nodePath = nodePath === '0' ? pathPrefix(n) : nodePath;
        match = nodePath === pathPrefix(n);
      }
    });
    return match;
  };

  return checkIfPathsMatch(node);
};

// ***************************************************************************
export const addparenItem = isOpen => {
  return {
    node: '',
    recType: ' ',
    keyword: isOpen ? '(' : ')',
    shortText: isOpen ? '(' : ')',
    shortTextCatgView: isOpen ? '(' : ')',
    objectType: 'operator',
  };
};

export const addOperatorItem = node => {
  return {
    node: '',
    recType: ' ',
    keyword: node,
    shortText: node,
    shortTextCatgView: node,
    objectType: 'operator',
  };
};

// functions to combine ['AND', 'NOT'] in an expression to ['AND NOT']

export const combineOperatorForExpressions = expressionList => {
  const expressionFormed = [...expressionList];

  for (let i = 0; i < expressionFormed.length - 1; i += 1) {
    if (
      expressionFormed[i] === AC_OPERATORS.type.and.label &&
      expressionFormed[i + 1] === AC_OPERATORS.type.not.label
    ) {
      expressionFormed.splice(i, 2, AC_OPERATORS.type.andnot.label);
    } else if (
      expressionFormed[i] === AC_OPERATORS.type.or.label &&
      expressionFormed[i + 1] === AC_OPERATORS.type.not.label
    ) {
      expressionFormed.splice(i, 2, AC_OPERATORS.type.ornot.label);
    }
  }
  return expressionFormed;
};

export const combineOperatorForObjectsAdded = objectsAddedList => {
  const objectsAdded = cloneDeep(objectsAddedList);

  for (let i = 0; i < objectsAdded.length - 1; i += 1) {
    if (
      objectsAdded[i].keyword === AC_OPERATORS.type.and.label &&
      objectsAdded[i + 1].keyword === AC_OPERATORS.type.not.label
    ) {
      objectsAdded.splice(
        i,
        2,
        addOperatorItem(AC_OPERATORS.type.andnot.label)
      );
    } else if (
      objectsAdded[i].keyword === AC_OPERATORS.type.or.label &&
      objectsAdded[i + 1].keyword === AC_OPERATORS.type.not.label
    ) {
      objectsAdded.splice(i, 2, addOperatorItem(AC_OPERATORS.type.ornot.label));
    }
  }
  return objectsAdded;
};

/* Takes any expression and returns it in an array seperating the keywords,braces and operators
  Eg: ((X603884  OR X603885 ) OR X603887 ) = ['(','(','X603884','OR','X603885',')','OR','X603887',')'] */
export const getExpressionFormed = keyword => {
  const expressionFormed = [];
  let tempWord = '';
  // const patt = /[a-zA-Z0-9]/;

  // eslint-disable-next-line no-restricted-syntax
  for (const c of keyword) {
    if (c === '(' || c === ')') {
      if (tempWord.trim() !== '') expressionFormed.push(tempWord.trim());
      expressionFormed.push(c);
      tempWord = '';
    } else if (c.trim() === '' && tempWord.trim() !== '') {
      expressionFormed.push(tempWord.trim());
      tempWord = '';
    } else if (c.trim() === ',') {
      if (tempWord.trim() !== '') expressionFormed.push(tempWord.trim());
      tempWord = '';
    } else tempWord += c;
  }
  if (tempWord.trim() !== '' && !expressionFormed.includes(tempWord.trim())) {
    expressionFormed.push(tempWord.trim());
    tempWord = '';
  }

  return combineOperatorForExpressions(expressionFormed);
};

export const checkKeywords = item => {
  const num = /^\d+$/;
  const decNum = /^\d+\.\d{0,10}$/;

  return (
    item &&
    item !== '(' &&
    item !== ')' &&
    item !== AC_OPERATORS.type.and.label &&
    item !== AC_OPERATORS.type.or.label &&
    item !== AC_OPERATORS.type.not.label &&
    item !== AC_OPERATORS.type.xor.label &&
    item !== AC_OPERATORS.type.andnot.label &&
    item !== AC_OPERATORS.type.ornot.label &&
    !num.test(item) &&
    !decNum.test(item) &&
    item.trim() !== '' &&
    !specialCharList.includes(item) &&
    // item !== ',' &&
    // item !== '+' &&
    !functionsInComposer.includes(item.toUpperCase()) &&
    !GEOGRAPHY_BASES.includes(item)
  );
};

export const getKeywordList = (list, fromSelectionBox) => {
  const keywordsList = [];
  list.forEach(item => {
    const keyword = fromSelectionBox ? item.data.expression : item.expression;

    getExpressionFormed(keyword).forEach(item => {
      if (checkKeywords(item)) {
        keywordsList.push(item);
      }
    });
  });
  return keywordsList;
};

export const buildDictionaryItem = (label, node) => {
  // const node = keywordsList[label];
  let dicItem;

  if (!node || !node.labels) {
    // console.log('Node: ', node);
    // console.log('Labels: ', label);
    dicItem = addOperatorItem(label);
  } else {
    const d = new Date();
    dicItem = {
      breadcrumbs: node.labels.join(' > '),
      lastModified: `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`,
      labels: node.labels,
      keyword: label, // "ESPNDEP"
      midpoint: node.midpoint,
      modeled: false,
      node: node.node,
      objectType: 'operand',
      pathId: node.pathId,
      path: node.pathId,
      datatype: node.recType,
      recordType: node.recType,
      rectype: node.recTag,
      shortText: `${node.labels[node.labels.length - 2]}: ${
        node.labels[node.labels.length - 1]
      }`,
      shortTextCatgView: node.labels[node.labels.length - 1],
      textPath: node.textPath,
      uniqueId: uuid(),
      nodeLabel:
        node.templateType === TEMPLATE_TYPE_1 &&
        node.labels.includes(TEMPLATE_1_NODE_CATEGORY)
          ? TEMPLATE_1_NODE_CATEGORY
          : node.templateType === TEMPLATE_TYPE_1 &&
            node.labels.includes('Brand')
          ? 'Brand'
          : node.templateType === TEMPLATE_TYPE_1 &&
            node.labels.includes('Type')
          ? 'Type'
          : node.labels[node.labels.length - 2],
      template: node.templateType,
    };
  }
  return dicItem;
};

export const buildGeographyItems = (expressions, keywordsList) => {
  const d = new Date();
  let node = {};
  let newExpressionsList = [];
  let isgeoDataPoint = false;
  let selectedKeyword = '';
  GEOGRAPHY_BASES.forEach(keyword => {
    if (expressions.includes(keyword) && selectedKeyword === '') {
      isgeoDataPoint = true;
      selectedKeyword = keyword;
    }
  });
  if (isgeoDataPoint) {
    newExpressionsList = extractGeoExpression(
      expressions.trim(),
      newExpressionsList,
      selectedKeyword
    ).filter(item => checkKeywords(item));
  }

  if (newExpressionsList.length > 1) {
    // multiple joint expression goes here
    node = cloneDeep(keywordsList[newExpressionsList[0].trim()]);
    const labels = cloneDeep(node.labels);
    labels.pop();
    let finalLabel = '';
    newExpressionsList.forEach((element, index) => {
      const listLabel = keywordsList[element.trim()].labels;
      finalLabel =
        index === 0
          ? `${listLabel[listLabel.length - 1]}`
          : `${finalLabel}, ${listLabel[listLabel.length - 1]}`;
    });
    labels.push(finalLabel);
    node.labels = labels;
  } else {
    node = cloneDeep(keywordsList[expressions.trim()]);
  }
  return {
    breadcrumbs: node.labels.join(' > '),
    lastModified: `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`,
    labels: node.labels,
    keyword: expressions,
    midpoint: node.midpoint,
    modeled: false,
    node: node.node, // need to check
    objectType: 'operand',
    pathId: upperCase(node.subType),
    path: upperCase(node.subType),
    datatype: 'G',
    recordType: 'G',
    rectype: 'L',
    shortText: `${node.labels[node.labels.length - 1]}`,
    shortTextCatgView: node.labels[node.labels.length - 1],
    shortTextPrifix: 'G',
    sortText: `${node.labels[node.labels.length - 1]}`,
    textPath: node.textPath,
    uniqueId: uuid(),
    nodeLabel: `${node.labels[0]}`,
  };
};

export const getObjectAdded = (expressionFormed, keywordsList) => {
  const objectAdded = [];

  expressionFormed.forEach(item => {
    switch (item) {
      case '(':
        objectAdded.push(addparenItem(true));
        break;
      case ')':
        objectAdded.push(addparenItem(false));
        break;
      case AC_OPERATORS.type.and.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.and.label));
        break;
      case AC_OPERATORS.type.or.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.or.label));
        break;
      case AC_OPERATORS.type.andnot.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.andnot.label));
        break;
      case AC_OPERATORS.type.ornot.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.ornot.label));
        break;
      case AC_OPERATORS.type.xor.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.xor.label));
        break;
      case AC_OPERATORS.type.not.label:
        objectAdded.push(addOperatorItem(AC_OPERATORS.type.not.label));
        break;
      default: {
        if (GEOGRAPHY_BASES.some(elem => item.includes(elem))) {
          objectAdded.push(buildGeographyItems(item, keywordsList));
        } else {
          // if (Object.prototype.hasOwnProperty.call(keywordsList, item)) {
          objectAdded.push(buildDictionaryItem(item, keywordsList[item]));
          // } else {
          //   objectAdded.push(addOperatorItem(item));
        }
        break;
      }
    }
  });

  return objectAdded;
};

export const createDictionaryElementForKeyword = (
  keywordsList,
  defItems,
  fromSelectionBox
) => {
  const modifiedDictionaryItems = [];

  defItems.forEach(item => {
    const keyword = fromSelectionBox ? item.data.expression : item.expression;
    const title = fromSelectionBox ? item.data.title : item.title;
    const expressionFormed = getExpressionFormed(keyword);
    const objectsAdded = getObjectAdded(expressionFormed, keywordsList);

    const containsNotFunction = expressionFormed.some(
      item => item === AC_OPERATORS.type.not.label
    );
    if (containsNotFunction) {
      modifiedDictionaryItems.push(
        buildAutocodenodeWithNot(expressionFormed, keywordsList, title)
      );
    } else {
      modifiedDictionaryItems.push(
        buildAutoCodeObject(expressionFormed, objectsAdded)
      );
    }
  });

  return modifiedDictionaryItems;
};

// Parses time period label from a shortText label
export const getTimePeriodFromShortText = shortText => {
  if (!shortText) return null;

  // if label includes a '/' ...
  if (shortText.includes('/')) {
    // time period is everything after it...
    return shortText.split('/')[1];
  }
  // ... else time period is last three words of label
  const lastThreeWords = shortText.split(' ').slice(-3);
  return lastThreeWords.join(' ');
};

// Checks if the autocodenode contains the combine(), toLabelString(),
// toExpressionString(), etc functions and adds them recursively if not present.
export const checkAndAddFunctionInAutocodeNode = autocodenode => {
  if (
    Object.prototype.hasOwnProperty.call(autocodenode, 'combine') &&
    Object.prototype.hasOwnProperty.call(autocodenode, 'toLabelString') &&
    Object.prototype.hasOwnProperty.call(autocodenode, 'toExpressionString') &&
    Object.prototype.hasOwnProperty.call(autocodenode, 'toExpressionArray')
  ) {
    const updatedNode = cloneDeep(autocodenode);
    updatedNode.selected = false;
    return updatedNode;
  }
  const { toLabelString, toDefString } = AutocodeLabelsGenerator(
    ACStandardLabels,
    null
  );
  const { buildObjectsAddedArray } = AutocodeExpressionListGenerator();

  const addPropertyToNode = node => {
    const funcNode = _.cloneDeep(node);

    funcNode.combine = function combine() {
      return combineAllChildren(this);
    };
    funcNode.toLabelString = function LabelString(pts) {
      return toLabelString(this, pts);
    };

    funcNode.toExpressionString = function toExpressionString() {
      return toDefString(this);
    };
    funcNode.toExpressionArray = function toExpressionArray(pts) {
      return buildObjectsAddedArray(this, pts);
    };

    funcNode.selected = false;

    if (node.type === AC_NODETYPE_OPERATOR) {
      // handles Operator nodes
      const children = [];
      children.push(addPropertyToNode(node.children[0]));
      children.push(addPropertyToNode(node.children[1]));
      funcNode.children = [...children];
    } else if (node.type === AC_NODETYPE_FUNC) {
      // handles Function nodes
      const children = [];
      node.children.forEach(item => {
        children.push(addPropertyToNode(item));
      });
      funcNode.children = [...children];
    }
    return funcNode;
  };

  return addPropertyToNode(autocodenode);
};

// This is a hack for PLAT-11255
// Show alternate answer labels when a function is applied.
export const getAnswerForLevel = (datapoint, answerIndex, showTimePeriod) => {
  const { labels, timePeriod, template } = datapoint;

  // Default case
  // Don't show time period and return normal answer label
  if (!showTimePeriod || !timePeriod) return labels[answerIndex];

  // T1 Category is template 1 and 'Category' somewhere in heirarchy
  const isT1Category =
    template === TEMPLATE_TYPE_1 &&
    labels.some(l => l === TEMPLATE_1_NODE_CATEGORY);
  // T1 Range item if is T1 Category and answer label has
  // Heavy, Medium, Light, Category N+ or starts with number
  const isT1RangeItem =
    isT1Category &&
    (/Heavy|Medium|Light|Category/g.test(labels[labels.length - 1]) ||
      /^\d+/g.test(labels[labels.length - 1]));

  // If T1 Category...
  if (isT1Category) {
    // If Range item...
    // Append time period to first part of answers label.
    // Split answer label on time period label prefix to get correct part.
    if (isT1RangeItem) {
      return `${
        labels[answerIndex].split(TEMPLATE_1_TIME_PERIOD_LABEL_PREFIX)[0]
      } ${timePeriod}`;
    }
    // If not Range item just return time period as answer
    return timePeriod;
  }

  // If not T1 Category just append time period to answer label
  return `${labels[answerIndex]}_${timePeriod}`;
};

// This is a hack for PLAT-11255
// Get flag to show time period. Only true for the VOL funcs.
export const getShowTimePeriod = funcName =>
  ['VOL', 'MEAN VOL', 'MEDIAN VOL'].includes(funcName);
